






















































































































import { Vue, Component, Prop, Watch, Mixins, Ref } from "vue-property-decorator";
import dayjs from "dayjs";
import { BvModalEvent } from "bootstrap-vue";
import { VIPCompanyEditViewMixin } from "@/mixins/VIPCompanyMixin";
import {
	db,
	auth,
	busy,
	DBType,
	VIPCompany,
	VIPProject,
	VIPContact,
	VIPContactRest,
	VIPCompanyRest,
	VIPUserRest,
	WPMediaRest,
	WPMedia,
	IVIPCompany,
	IVIPCompanyRestGetParams,
	vip,
} from "@/loader/public";
import ContactEdit from "../component/contact/ContactEdit.vue";
import ContactsTable from "../component/contact/ContactsTable.vue";
import ProjectsTable from "../component/project/ProjectsTable.vue";
import UploadFileModal from "../component/UploadFileModal.vue";

@Component({
	name: "CompanyView",
	components: {
		ContactEdit,
		ContactsTable,
		ProjectsTable,
		UploadFileModal,
	}
})
export default class CompanyView extends Mixins(VIPCompanyEditViewMixin({
	redirection: { name: "Companies" },
	loadMessage: "Chargement du client ...",
	getParams: {
		options: {
			contacts: true,
			manager: true,
			projects: {
				ips: true,
				manager: true,
				certificates: {
					ips: true,
					events: { event: true },
				},
			},
		},
	},
})) {
	public contact: VIPContact | null = null;
	public project: VIPProject | null = null;

	@Ref()
	public contactsTable!: ContactsTable;

	public get canDelete(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return !!auth.user.capabilities.delete_vip_company && (
			auth.user.isManagerOrAbove
			&& !this.item.projects.length
			&& !this.item.contacts.length
		);
	}

	public get canCreateProject(): boolean {
		return auth.user?.capabilities.create_vip_project || false;
	}

	public get canCreateContact(): boolean {
		return auth.user?.capabilities.create_vip_contact || false;
	}

	public get canEditContact(): boolean {
		return auth.user?.capabilities.edit_vip_contact || false;
	}

	public get canDeleteContact(): boolean {
		return auth.user?.capabilities.delete_vip_contact || false;
	}

	public edit() {
		vip.showCompany(this.item);
	}

	public saved(item: VIPCompany) {
		if (item && this.id !== item.id) {
			this.$router.push({ name: "Company", params: { id: item.id } });
		}
	}

	public removed() {
		this.$router.push({ name: "Companies" });
	}

	public addProject() {
		if (this.canCreateProject && this.item) {
			let project = db.projects.insert({
				id: db.projects.list.nextNewId(),
				fk_company: this.item.id,
				name: "Nouveau Projet",
			});
			this.$router.push({ name: "Project", params: { id: project.id } });
		}
	}

	public addContact() {
		this.contact = db.contacts.insert({
			id: db.contacts.list.nextNewId(),
			fk_company: this.item?.id,
			last_name: "Nouveau contact",
		});
	}

	public uploadLogo(file: File) {
		if (this.canEdit && this.item) {
			busy.start("Sauvegarde du logo ...");
			let media = new WPMedia({
				date: dayjs(),
				date_gmt: dayjs.utc(),
				slug: this.item.name.kebabCase(),
				status: "publish",
				title: { raw: this.item.name },
				alt_text: this.item.name,
				author: auth.user?.id,
				comment_status: "closed",
				ping_status: "closed",
			});
			WPMediaRest.create(media, file).then(result => {
				if (result.success && this.item && result.item) {
					this.item.fk_logo = result.item.id;
					return VIPCompanyRest.update(this.item);
				}
				return result;
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public selectContact(contact: VIPContact | null, refreshTable: boolean) {
		this.contact = contact;
		if (refreshTable && this.contactsTable) {
			this.contactsTable.refresh();
		}
	}

	public loadDependencies() {
		if (this.item) {
			if (!this.item.manager) {
				VIPUserRest.get({ id: this.item.fk_manager });
			}
			if (!this.item.contacts.length) {
				VIPContactRest.list({ fk_company: this.item.id });
			}
		}
	}
}
